import {useEffect, useState} from "react";
import associateServices from "../../../../services";
import ActiveRaces from "./active-races";
import RacesHistory from "./history-races";
import {useSelector} from "react-redux";

const Races = props => {

    const {username} = props


    return (
        <div
            className="tab-pane fade show active">
            <div className="row">
                <div className="col-12">
                    <div className="modal__subtitle">
                        <h6>Latest Races</h6>
                    </div>
                </div>

                <ActiveRaces username={username}/>

                <RacesHistory username={username}/>


            </div>
        </div>

    )

}

export default Races
